import React, { useState } from 'react';
import { Container, Table, Button, Modal } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import TradeEntry from '../trade/TradeEntry';
import { Trade } from '../../data/StaticData';
import OrderEntry from './OrderEntry';


const OrderBook = () => {
  const [viewModal, setViewModal] = useState(false);
  const [newModal, setNewModal] = useState(false);

  const [selectedRow, setSelectedRow] = useState(null);

  const handleViewShow = () => setViewModal(true);
  const handleViewClose = () => setViewModal(false);

  const handleNewShow = () => setNewModal(true);
  const handleNewClose = () => setNewModal(false);

  const handleRowDoubleClick = (row) => {
    setSelectedRow(row);
    handleViewShow();
  };

  // JSON Data
  const jsonData = {
    agent1: "SICO BH",
    trader: "Ali Marshad",
    // Add other fields here based on your data
  };

  const data = [
    { ccy: 'BHD', isin: 'BH0006FH0881', name: 'BHDB 3.75 01/10/26 5YR', settlement: 'CBB', haircut: 100, term: 'ON', start: '17-Oct', end: '18-Oct-23', bidSize: '100M', bidRate: 0.90, askRate: 0.85, askSize: '50M' },
    { ccy: 'BHD', isin: 'BH0006FH0881', name: 'BHDB 3.75 01/10/26 5YR', settlement: 'CBB', haircut: 100, term: 'TN', start: '18-Oct', end: '19-Oct-23', bidSize: '100M', bidRate: 0.90, askRate: 0.85, askSize: '50M' },
    { ccy: 'BHD', isin: 'BH0006FH0881', name: 'BHDB 3.75 01/10/26 5YR', settlement: 'CBB', haircut: 100, term: 'SN', start: '19-Oct', end: '20-Oct-23', bidSize: '100M', bidRate: 0.90, askRate: 0.85, askSize: '50M' },
    { ccy: 'BHD', isin: 'BH0006FH0881', name: 'BHDB 3.75 01/10/26 5YR', settlement: 'CBB', haircut: 100, term: 'S1W', start: '19-Oct', end: '26-Oct-23', bidSize: '50M', bidRate: 0.95, askRate: 0.90, askSize: '25M' },
    { ccy: 'BHD', isin: 'BH0006FH0881', name: 'BHDB 3.75 01/10/26 5YR', settlement: 'CBB', haircut: 100, term: 'S1M', start: '19-Oct', end: '18-Nov-23', bidSize: '50M', bidRate: 1.00, askRate: 0.90, askSize: '25M' },
    { ccy: 'BHD', isin: 'BH0006FH0881', name: 'BHDB 3.75 01/10/26 5YR', settlement: 'CBB', haircut: 100, term: 'S3M', start: '19-Oct', end: '18-Jan-24', bidSize: '50M', bidRate: 1.00, askRate: 0.90, askSize: '25M' },
    { ccy: 'BHD', isin: 'BH0006FH0881', name: 'BHDB 3.75 01/10/26 5YR', settlement: 'CBB', haircut: 100, term: 'S6M', start: '19-Oct', end: '18-Apr-24', bidSize: '50M', bidRate: 1.00, askRate: 0.90, askSize: '25M' },
    { ccy: 'BHD', isin: 'BH0006FH0881', name: 'BHDB 3.75 01/10/26 5YR', settlement: 'CBB', haircut: 100, term: 'S12M', start: '19-Oct', end: '18-Oct-24', bidSize: '50M', bidRate: 1.00, askRate: 0.90, askSize: '25M' }
  ];

  return (
    <Container>
      <div style={{ overflowY: 'auto', maxHeight: '400px' }}>
        <Table striped bordered hover>
          <thead style={{ position: 'sticky', top: 0, backgroundColor: 'white', zIndex: 1 }}>
            <tr>
              <th>Ccy</th>
              <th>Isin</th>
              <th>Name</th>
              <th>Settlement</th>
              <th>Haircut</th>
              <th>Term</th>
              <th>Start</th>
              <th>End</th>
              <th style={{ backgroundColor: 'lightgreen' }}>BidSize</th>
              <th style={{ backgroundColor: 'lightgreen' }}>BidRate</th>
              <th style={{ backgroundColor: 'lightcoral' }}>AskRate</th>
              <th style={{ backgroundColor: 'lightcoral' }}>AskSize</th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, index) => (
              <tr key={index} onClick={() => handleRowDoubleClick(row)} style={index === 3 ? { backgroundColor: 'lightgrey' } : {}}>
                <td>{row.ccy}</td>
                <td>{row.isin}</td>
                <td>{row.name}</td>
                <td>{row.settlement}</td>
                <td>{row.haircut}</td>
                <td>{row.term}</td>
                <td>{row.start}</td>
                <td>{row.end}</td>
                <td style={{ backgroundColor: 'lightgreen' }}>{row.bidSize}</td>
                <td style={{ backgroundColor: 'lightgreen' }}>{row.bidRate}</td>
                <td style={{ backgroundColor: 'lightcoral' }}>{row.askRate}</td>
                <td style={{ backgroundColor: 'lightcoral' }}>{row.askSize}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
      <Button variant="primary" onClick={handleNewShow}>NEW</Button>

      <Modal className="modal-lg" show={newModal} onHide={handleNewClose}>
        <Modal.Header closeButton>
          <Modal.Title>Order</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <OrderEntry mode="new"/>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleNewClose}>Close</Button>
        </Modal.Footer>
      </Modal>

      <Modal className="modal-lg" show={viewModal} onHide={handleViewClose}>
        <Modal.Header closeButton>
          <Modal.Title>Order</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <OrderEntry mode="view" readOnly={true} order={selectedRow}/>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleViewClose}>Close</Button>
        </Modal.Footer>
      </Modal>

    </Container>
  );
};

export default OrderBook;


/** add this back later
 * <PDFViewer style={{ width: '100%', height: '90vh' }}>
                <TradeConfirmationDocument data={jsonData} />
            </PDFViewer>
 */